var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('b-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"tw-text-3xl tw-font-medium tw-mb-2 text-aegis-dk"},[_vm._v(_vm._s(_vm.title)+" Metrics")]),_c('ClusterEnrollment')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }